import axios from './Axios';

const path = '/account';

export const getProfile = () => axios.get(`${path}/profile`);

export const getProfileDetails = () => axios.get(`${path}/profile`);

export const updateContactEmail = (email) =>
  axios.post(`${path}/profile/update`, { contact_email: email });

export const changePassword = (data) =>
  axios.post(`${path}/profile/changepassword`, data);

const addressPath = '/address';

const getAddresses = () => axios.get(`${path}${addressPath}/all`);

const createAddress = (data) =>
  axios.put(`${path}${addressPath}/new`, { data });

const updateAddress = (id, data) =>
  axios.post(`${path}${addressPath}/update`, { address: id, data });

const setPrimaryAddress = (id) =>
  axios.post(`${path}${addressPath}/primary`, { address: id });

const deleteAddress = (id) =>
  axios.delete(`${path}${addressPath}/delete`, {
    data: { address: id },
  });

const phonePath = '/phone';

const getAllPhones = () => axios.get(`${path}${phonePath}/all`);

const createPhone = (data) => axios.put(`${path}${phonePath}/new`, { data });

const setPrimaryPhone = (id) =>
  axios.post(`${path}${phonePath}/primary`, { phone: id });

const deletePhone = (id) =>
  axios.delete(`${path}${phonePath}/delete`, { data: { phone: id } });

export default {
  getProfile,
  getProfileDetails,
  updateContactEmail,
  changePassword,
  address: {
    getAddresses,
    createAddress,
    updateAddress,
    setPrimaryAddress,
    deleteAddress,
  },
  phone: {
    getAllPhones,
    createPhone,
    setPrimaryPhone,
    deletePhone,
  },
};
